<ng-select 
    [items]="accounts"
    bindLabel="name"
    bindValue="name"
    groupBy="country"
    [(ngModel)]="selectedAccount"
>
    <ng-template ng-optgroup-tmp let-item="item">
        {{item.country || 'Unnamed group'}}
    </ng-template>
</ng-select>

<br>
<small>Selected: {{selectedAccount | json}}</small>

